import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import AutoComplete from 'material-ui/AutoComplete';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import cookie from 'js-cookie';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { generateFacebookTargetingSpec } from '../../../helpers/facebookAdTargeting';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import TextField from 'material-ui/TextField';
import { Accordion, AdStep2Preview, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton } from 'components';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import { setLeadAdBuilderValue, initLeadAdBuilder, setLeadAdBuilderBullet } from 'redux/modules/adBuilder';
var ShortAnswerQuestion = (_dec = connect(function (state) {
  return {};
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ShortAnswerQuestion, _Component);

  var _super = _createSuper(ShortAnswerQuestion);

  function ShortAnswerQuestion() {
    _classCallCheck(this, ShortAnswerQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(ShortAnswerQuestion, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '1rem',
          margin: '1rem',
          border: '1px solid rgb(225, 225, 225)'
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 12,
          marginBottom: 12,
          marginLeft: 0,
          marginRight: 0,
          fontWeight: '500'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-font",
        "aria-hidden": "true"
      }), " Short Answer"), /*#__PURE__*/React.createElement(TextField, {
        hintText: "Enter a question to ask the person filling out this form.",
        fullWidth: true,
        onChange: this.props.onChange,
        value: this.props.question
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'right',
          color: '#5b5b9d',
          cursor: 'pointer'
        },
        onClick: this.props.handleRequestDelete
      }, "Remove question"));
    }
  }]);

  return ShortAnswerQuestion;
}(Component)) || _class);
export default ShortAnswerQuestion;